import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Spacer } from 'foundations-components/components/Spacer';
import { HeaderLeftBorder } from './HeaderLeftBorder';
import { ResizeAffordance } from './ResizeAffordance';
import { ContextMenuHeaderTriggerButton } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';

/**
 * Shared component for column headers with and without DnD.
 * It lays out the column header to compensate the space when DnD'ing a column.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ContentComponentInner({
  arrowsNode,
  children,
  columnName,
  columnNamespace,
  draggedLeft,
  draggedRight,
  isDragging,
  onClick,
  onMouseDown,
  resizable,
  reorderable
}) {
  const dragAndDropStatus = resizable ? 'dnd' : 'no-dnd';
  const dataTestId = `content-component-${dragAndDropStatus}-${columnName}`;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "100%",
    "data-test-id": dataTestId,
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(HeaderLeftBorder, {
        $shouldHighlight: reorderable && !isDragging && draggedLeft
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: "300"
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: children
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "100",
        paddingInline: "200",
        children: arrowsNode
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(ContextMenuHeaderTriggerButton, {
        columnNamespace: columnNamespace,
        columnName: columnName
      })
    }), resizable && /*#__PURE__*/_jsx(Box, {
      blockSize: "100%",
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(ResizeAffordance, {
        "data-test-id": `resize-header-${columnNamespace}-${columnName}`,
        onClick: onClick,
        onMouseDown: onMouseDown,
        $shouldHighlight: !isDragging && draggedRight
      })
    })]
  });
}
export default /*#__PURE__*/memo(ContentComponentInner);